import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Empty, Grid, Modal, Skeleton, Space, Switch, Table, TablePaginationConfig, Tooltip } from 'antd';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import { Column, RecordCountBadge } from 'components';
import {
  StyledTableHeader,
  StyledTableWrapper,
} from 'components/table/table.styled';
import { TableLoader } from 'components/table-loader/table-loader';
import {
  EventsFilterFormValues
} from 'features/events';
import { useEventActiveStatus } from 'features/events/use-cases/event-active-status';
import { useEventDeleteStatus } from 'features/events/use-cases/event-delete-status';
import { useGetCampignCode } from 'features/events/use-cases/get-marketing-campign-code';
import { usePermissions } from 'features/users';
import { usePaginationParams } from 'hooks';
import { useEffect, useState } from 'react';
import { Event } from 'types/event';

import { AddCampaignCodeModal } from './add-campaign-code-modal/add-campaign-code-modal';


const { useBreakpoint } = Grid;


export const EventCampaignCodeComponent = ({ id, tabs }: { id: string; tabs: string }) => {
  const screens = useBreakpoint();
  const permissions = usePermissions();

  const initialFilterValues: EventsFilterFormValues = {
    field_name: undefined,
  };

  const { params, updateParams } =
    usePaginationParams<any>({
      event_id: id,
      page: 1,
      size: 10,
      order_by: '',
      ...initialFilterValues,
    });

  const { data, isLoading, refetch } = useGetCampignCode(params, { retry: false });
  const [showAddPriceModal, setShowAddPriceModal] = useState<boolean>(false);
  const [editId, setEditId] = useState<string | null>(null);


  const handleCloseModal = () => {
    document.body.style.overflow = 'visible';
    setEditId(null);
    setShowAddPriceModal(false);
  }


  const handleOpenModal = (record: any) => {
    document.body.style.overflow = 'hidden';
    setEditId(record);
    setShowAddPriceModal(true);
  }


  const handleTableChange = (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<Event> | SorterResult<Event>[],
  ) => {
    updateParams({
      ...params,
      page: pagination.current,
      size: pagination.pageSize,
      order_by: Array.isArray(sorter)
        ? undefined
        : sorter.order === 'ascend'
          ? 'name'
          : '-name',
    });
  };
  ;

const tableWidth = screens.xxl ? { x: 1440 } : { x: 1200 };

  const { mutate } = useEventDeleteStatus();

  const handleDelete = (record: any) => {
    const deletedFormData = {
      id: record.id,
      status: false,
      flag: "EVENT_CAMPAIGN_DELETE"
    }
    mutate(deletedFormData);
  }

  const { mutate: updateStatusMutate, isLoading: statusLoading } = useEventActiveStatus();

  const handleUpdateStatus = (updateId: any, isChecked: any) => {
    const statusFormData = {
      id: updateId,
      status: isChecked,
      flag: "EVENT_CAMPAIGN_SET_STATUS"
    }
    updateStatusMutate(statusFormData);
  }






  const { confirm } = Modal;

  const showDeleteConfirm = (event: any, record: any) => {
    event.stopPropagation();
    confirm({
      title: 'Are you sure you want to delete this Ticket?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        handleDelete(record);
      },
    });
  };

  useEffect(() => {
    if (tabs == "1") {
      refetch();
    }
  }, [tabs])

  // if (isLoading) return <Loader />;

  if (!permissions) return null;

  return (

    <>
      <div className={`cstmrightmdl ${showAddPriceModal ? "show" : ''}`}>
        <AddCampaignCodeModal id={id} onClose={handleCloseModal} showAddPriceModal={showAddPriceModal} editId={editId} refetch={refetch} />
      </div>


      <StyledTableWrapper>
        <StyledTableHeader>
          <div className='tket_head'>
            <RecordCountBadge
              text={"Campaign Code found"}
              count={data?.total || 0}
            />


            <Button
              icon={<PlusOutlined />}
              onClick={() => handleOpenModal(null)}
              type='primary'
            >
              Add Campaign Code

            </Button>


          </div>

        </StyledTableHeader>
        <Table<Event>
          locale={{
            emptyText: isLoading ? <Skeleton active={true} /> : <Empty />
          }}
          loading={isLoading && { indicator: <div><TableLoader /></div> }}
          dataSource={isLoading ? [] : data?.items}
          rowKey='id'
          onChange={handleTableChange}
          pagination={{
            current: params.page,
            defaultPageSize: params.size,
            total: data?.total,
          }}
          className='event_table cstltblwthldr'
        scroll={tableWidth}

        >
          <Column<Event>
            title={'Compaign Code'}
            dataIndex={'campaign_code'}
            sorter={true}
            sortDirections={['ascend', 'descend', 'ascend']}
            defaultSortOrder={'descend'}
            width={screens.xxl ? 'auto' : 100}
            ellipsis

          />

          <Column<Event>
            title={'Provider'}
            dataIndex={'provider'}
            width={screens.xxl ? 'auto' : 200}
            className='cell-direction-rtl'
            ellipsis

          />

          <Column<Event>
            title={"Action"}
            width={screens.xxl ? 'auto' : 162}
            dataIndex={'is_active'}
            render={(_, record) => (
              <>
                <Space>
                  <Tooltip title="Edit">
                    <Button shape="circle" icon={<EditOutlined />} onClick={() => handleOpenModal(record)} />
                  </Tooltip>

                  <Tooltip title="Delete">
                    <Button shape="circle" icon={<DeleteOutlined />} onClick={(event) => showDeleteConfirm(event, record)} />
                  </Tooltip>
                  <Tooltip title="Is Active">
                    <Switch
                      defaultChecked={record.is_active}
                      checked={record.is_active}
                      loading={statusLoading}
                      onChange={(isChecked) => handleUpdateStatus(record.id, isChecked)}
                    />
                  </Tooltip>
                </Space>
              </>
            )}
          />
        </Table>

      </StyledTableWrapper>
    </>
  );
};



